var _path, _polyline, _path2, _path3, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailCampaignCreated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M291.33,444.91a55.09,55.09,0,0,0-26.84-27.57c-11.88-5.56-38.37-3-38.37-3l-69.62-.15c1.43,6.12,6,21.82,9.35,27.1s8.4,9.74,14.44,11.45c7.39,2.09,15.22-.07,22.89-.57,13.49-.87,26.69,3.49,39.68,7.24s26.78,6.93,39.92,3.75c3.73-.91,7.64-2.57,9.45-5.95C294.24,453.48,293,448.83,291.33,444.91Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.56,198.11s-7.92-.57-7.19,17.19,2.54,27.23,2.54,27.23-.23,3.93-3.28,3.16S60.84,241.09,58,244s-1.89,7.53,2,12.9,12,17.44,12.74,18.54,1,3.09-1.16,2.89-16.76-5.14-18.69,1.93,11.38,20.24,12.81,21.71,1.51,2.39.93,3.28-5.33-1.24-9.54-2.47S47.79,300.79,47,305s5.09,16.38,27.06,29.2l10.57,5.28,10-6.38c20.57-15,25.19-27.69,24-31.76s-6.19-2.87-10.25-1.22-8.58,4.24-9.24,3.42-.68-1.76.59-3.36,13.21-16,10.58-22.88-16.66-.46-18.79-.05-2-1.62-1.44-2.76,7.47-14,10.82-19.72,3.92-10.38.7-13-8.43,1.82-11.39,2.9-3.58-2.83-3.58-2.83.85-9.59-.2-27.34-9.06-16.31-9.06-16.31",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.19,214s0,.12,0,.37,0,.62.08,1.09c.07,1,.16,2.38.29,4.19.24,3.65.55,8.92.91,15.44.73,13,1.57,31.05,2.44,50.95s1.67,37.93,2.32,51c.33,6.51.6,11.78.79,15.44.09,1.81.16,3.22.21,4.2,0,.47,0,.83,0,1.09a3.64,3.64,0,0,1,0,.38s0-.13,0-.37,0-.63-.08-1.09c-.07-1-.17-2.39-.29-4.2-.24-3.64-.55-8.91-.91-15.43-.73-13-1.57-31.06-2.44-51s-1.67-37.92-2.32-51c-.34-6.5-.6-11.77-.79-15.44-.09-1.81-.16-3.22-.21-4.2,0-.46,0-.83,0-1.09A3.39,3.39,0,0,1,78.19,214Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.82,249.64a3.22,3.22,0,0,1,.65.54c.41.37,1,.92,1.68,1.61,1.4,1.39,3.27,3.34,5.3,5.55L78.62,263l1.57,1.71a3.11,3.11,0,0,1,.55.65,3.4,3.4,0,0,1-.66-.54c-.4-.37-1-.92-1.67-1.62-1.38-1.4-3.23-3.38-5.26-5.58L68,252c-.63-.66-1.15-1.23-1.59-1.7A3.22,3.22,0,0,1,65.82,249.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.79,265c-.08-.08,3.79-4.12,8.63-9s8.85-8.83,8.93-8.75-3.79,4.12-8.64,9S81.87,265.08,81.79,265Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.75,295.63a4.07,4.07,0,0,1,.74-.47L84.55,294c1.75-1,4.15-2.34,6.75-3.94s4.91-3.11,6.57-4.23l2-1.31a3.53,3.53,0,0,1,.75-.45,3.56,3.56,0,0,1-.66.58c-.44.34-1.09.83-1.9,1.42-1.63,1.18-3.92,2.74-6.53,4.34s-5,2.93-6.82,3.84c-.89.46-1.62.82-2.13,1.05A3.2,3.2,0,0,1,81.75,295.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.24,284.91a3.64,3.64,0,0,1,.73.34l1.92,1.07c1.61.91,3.81,2.2,6.24,3.64s4.61,2.77,6.18,3.75c.79.49,1.42.89,1.86,1.18a3.53,3.53,0,0,1,.65.47,2.81,2.81,0,0,1-.74-.34L79.17,294c-1.61-.92-3.82-2.2-6.25-3.65s-4.61-2.77-6.18-3.74c-.79-.49-1.42-.89-1.85-1.18A3.25,3.25,0,0,1,64.24,284.91Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.77,312a4.35,4.35,0,0,1,.93.45l2.46,1.35c2.06,1.16,4.91,2.79,8,4.61s6,3.49,8,4.71l2.4,1.47a5.14,5.14,0,0,1,.85.59,6.15,6.15,0,0,1-.93-.45L80,323.32c-2.07-1.16-4.91-2.79-8-4.61S66,315.22,64,314l-2.39-1.47A5,5,0,0,1,60.77,312Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83,324.66a5.09,5.09,0,0,1,.92-.62l2.57-1.56c2.16-1.32,5.15-3.16,8.4-5.27s6.13-4.1,8.22-5.55l2.47-1.72a5.74,5.74,0,0,1,.93-.59,5.35,5.35,0,0,1-.84.72c-.56.44-1.37,1.06-2.4,1.82-2,1.51-4.91,3.54-8.16,5.66s-6.27,3.92-8.48,5.18c-1.11.62-2,1.12-2.64,1.45A6.39,6.39,0,0,1,83,324.66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "98.85 342.9 69.61 342.9 79.16 415.14 89.31 415.14 98.85 342.9",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.13,351.78s0,.1.16.26a1.82,1.82,0,0,0,.7.5,3.54,3.54,0,0,0,3.09-.38c1.18-.65,2.21-1.93,3.79-2.49a8.29,8.29,0,0,1,5.38.1,23.23,23.23,0,0,1,5,2.43,34.89,34.89,0,0,0,4.08,2.18,11.09,11.09,0,0,0,3,.87,5,5,0,0,0,.85.06c.19,0,.29,0,.29,0a15.19,15.19,0,0,1-4-1.2,40,40,0,0,1-4-2.26,22.35,22.35,0,0,0-5.09-2.5,8.59,8.59,0,0,0-5.68-.06,7.4,7.4,0,0,0-2.13,1.32,15.49,15.49,0,0,1-1.68,1.29,3.45,3.45,0,0,1-2.84.5A3,3,0,0,1,71.13,351.78Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2,365.08s.23-.29.69-.77a6.45,6.45,0,0,1,2.33-1.48,10.45,10.45,0,0,1,4.07-.61,40.89,40.89,0,0,1,5.08.69,17.84,17.84,0,0,0,5.21.22,14.14,14.14,0,0,0,4.1-1.18,12.7,12.7,0,0,0,2.47-1.46,3.37,3.37,0,0,0,.78-.7,26.7,26.7,0,0,1-3.38,1.86,15.26,15.26,0,0,1-4,1,18.12,18.12,0,0,1-5.08-.25,38.25,38.25,0,0,0-5.15-.66,10.27,10.27,0,0,0-4.21.74,6,6,0,0,0-2.34,1.66,4.11,4.11,0,0,0-.44.65C72.22,365,72.18,365.08,72.2,365.08Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.54,372.21a2.42,2.42,0,0,0-.81-.42,8.25,8.25,0,0,0-2.42-.52,15.34,15.34,0,0,0-3.66.21c-1.37.22-2.83.6-4.36.92a18.1,18.1,0,0,1-4.36.49,9.47,9.47,0,0,1-3.45-.74,7.86,7.86,0,0,1-2.63-2,2.18,2.18,0,0,0,.5.77,6.09,6.09,0,0,0,2,1.49,9.23,9.23,0,0,0,3.58.88,17.21,17.21,0,0,0,4.47-.46c1.56-.33,3-.72,4.34-1a16.87,16.87,0,0,1,3.57-.3A13.2,13.2,0,0,1,95.54,372.21Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.78,382.23a4.69,4.69,0,0,1,2.84-.29,14,14,0,0,1,3,1.11,11.37,11.37,0,0,0,3.85,1.06,11.54,11.54,0,0,0,7-1.62,10.31,10.31,0,0,0,1.74-1.34c.36-.38.54-.6.51-.62a23.93,23.93,0,0,1-2.42,1.67,12.08,12.08,0,0,1-6.78,1.44c-2.77-.16-4.9-1.81-6.82-2a4.31,4.31,0,0,0-2.2.19C75,382,74.77,382.21,74.78,382.23Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.41,396.09a5.52,5.52,0,0,0,2.44-.48c1.47-.49,3.29-1.62,5.41-2.46a8.63,8.63,0,0,1,3.11-.65,5.66,5.66,0,0,1,2.5.57,5.37,5.37,0,0,1,1.8,1.55,1.36,1.36,0,0,0-.28-.61A3.85,3.85,0,0,0,90,392.77a5.71,5.71,0,0,0-2.65-.71,8.76,8.76,0,0,0-3.28.64c-2.2.88-4,2-5.37,2.59S76.4,396,76.41,396.09Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.84,402.54a6.82,6.82,0,0,0,1.85.61,37,37,0,0,0,4.63.78,34.22,34.22,0,0,0,4.69.13,7.16,7.16,0,0,0,1.94-.23c0-.14-3,0-6.58-.38S77.88,402.4,77.84,402.54Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 539.55,
    y: 230.19,
    width: 91.21,
    height: 61.48,
    transform: "translate(-43.43 136.92) rotate(-12.87)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.22,221.46a6.16,6.16,0,0,1-.65,1l-2,2.73-7.41,10c-6.37,8.44-15.09,20-24.76,32.8l-.2.27-.31-.15-.73-.35-37.47-18.2-11.32-5.59-3-1.56a6.54,6.54,0,0,1-1.05-.6,6.85,6.85,0,0,1,1.12.45l3.12,1.42L550,249l37.57,18,.74.36-.51.12c9.74-12.74,18.53-24.25,25-32.65,3.17-4.1,5.76-7.43,7.62-9.82l2.1-2.64A5.69,5.69,0,0,1,623.22,221.46Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548,301.72c-.2-.11,4.61-9.85,10.74-21.76s11.28-21.49,11.48-21.39-4.61,9.85-10.74,21.77S548.19,301.82,548,301.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.6,251.07c.14-.18,8.61,6.47,18.92,14.84s18.54,15.31,18.39,15.49-8.61-6.47-18.92-14.85S599.45,251.25,599.6,251.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.67,
    y: 54.69,
    width: 36.25,
    height: 53.78,
    transform: "translate(113.32 305.64) rotate(-77)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.14,70.44a4,4,0,0,1-.6.36l-1.75.94-6.5,3.38-21.57,11-.18.09-.13-.15-.3-.38L232.92,66.42l-4.56-5.89-1.22-1.61a2.94,2.94,0,0,1-.4-.58,3.72,3.72,0,0,1,.47.52l1.3,1.56,4.68,5.78L248.5,85.41l.3.37-.3-.06,21.63-10.9,6.57-3.25,1.8-.86A3.24,3.24,0,0,1,279.14,70.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.58,93.66c-.08-.11,5-4,11.3-8.78s11.51-8.5,11.59-8.39-5,4-11.3,8.78S218.66,93.77,218.58,93.66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259,80.07c.12-.06,2.91,5.65,6.22,12.74s5.89,12.89,5.77,13-2.9-5.65-6.21-12.74S258.87,80.12,259,80.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 524.39,
    y: 73.77,
    width: 41.67,
    height: 28.09,
    transform: "translate(9.62 222.4) rotate(-23.25)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.08,67a3.38,3.38,0,0,1-.21.49l-.66,1.39c-.61,1.24-1.47,3-2.51,5.1l-8.43,16.78-.07.14-.15,0-.36-.09-18.33-5.1L522.81,84l-1.5-.45-.52-.18a2.59,2.59,0,0,1,.54.11l1.52.38,5.58,1.47,18.36,5,.36.1-.21.1c3.32-6.53,6.33-12.43,8.52-16.73,1.09-2.1,2-3.82,2.62-5l.72-1.36A2.46,2.46,0,0,1,559.08,67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.88,109.21c-.1,0,1.26-4.81,3-10.67S538.22,88,538.32,88s-1.26,4.8-3,10.66S532,109.24,531.88,109.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.9,82.2c.05-.1,4.41,2.19,9.73,5.11s9.59,5.35,9.54,5.44-4.4-2.19-9.72-5.11S550.85,82.29,550.9,82.2Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M609.52,327.76A31.52,31.52,0,0,0,596,323.09c-2.21-.22-4.63-.16-6.41,1.18a1.35,1.35,0,0,0-.66,1.17,1.5,1.5,0,0,0,.63.8,19.37,19.37,0,0,0,20,1.52",
    style: {
      fill: "#5B5BF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.17,327.37a66.07,66.07,0,0,1-8.75-7.7,22,22,0,0,1-5.48-10.14,4.09,4.09,0,0,1,.43-3.4c7,5.45,12.45,12.5,13.8,21.24",
    style: {
      fill: "#5B5BF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.45,327.7a31.41,31.41,0,0,1,.16-11.48,15.51,15.51,0,0,1,6.12-9.48c1.2,2.81.69,6.06-.16,9a43.65,43.65,0,0,1-6.07,12.78",
    style: {
      fill: "#5B5BF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.29,340c-4.16.51-7.77,2.7-10.87,5.5a20.54,20.54,0,0,0-6.21,10.67c4.07-.25,7.52-3.12,10-6.34s4.24-6.75,7-9.76",
    style: {
      fill: "#5B5BF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.77,341.91a26.81,26.81,0,0,1,3.09-25.34c2.37,8.41,1.5,17.91-3.09,25.34",
    style: {
      fill: "#5B5BF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.8,352.67a19.39,19.39,0,0,0-18.52,10.67,1.44,1.44,0,0,0-.13,1.45,1.38,1.38,0,0,0,1.23.36c3.65-.24,6.89-2.43,9.56-4.93s5-5.4,7.95-7.56",
    style: {
      fill: "#5B5BF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.52,352.09a34.46,34.46,0,0,1-.35-19.28c.68-2.48,1.82-5.09,4.11-6.26a.84.84,0,0,1,.63-.11.86.86,0,0,1,.4.46,11.52,11.52,0,0,1,1,5.53,34.3,34.3,0,0,1-.86,5.6c-.73,3.42-1.11,7.1-3,10.05a20.42,20.42,0,0,0-1.19,2.21c-.36.75-.36,1-.68,1.61",
    style: {
      fill: "#5B5BF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.43,355.65c-1.77-6.74.11-14.91,4.36-20.44.31-.4.72-.84,1.23-.79.79.07,1,1.11,1,1.9a36.88,36.88,0,0,1-6.54,19.33",
    style: {
      fill: "#5B5BF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.59,357.12a29.73,29.73,0,0,0,24.39-5,19.79,19.79,0,0,0-13.21-1.62c-4.41,1-8.44,3-11.18,6.58",
    style: {
      fill: "#5B5BF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.4,352.63c4.59-7.47,13.38-12.35,22.14-12.8-1,3.57-3.94,6.34-7.24,8A40.4,40.4,0,0,1,658.67,351c-1.41.27-3.35.57-4.27,1.68",
    style: {
      fill: "#5B5BF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.89,330.86a64.24,64.24,0,0,0,2.83-13,21.58,21.58,0,0,0-2.59-12.83c-4.28,8.29-4.71,18-.37,26.24",
    style: {
      fill: "#5B5BF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.31,323.57c5-9.1,15.23-16.37,25.57-17.39-4,9.93-14.87,17.61-25.57,17.39",
    style: {
      fill: "#5B5BF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.15,325.36c7.48,1.13,13.84,5.91,20.82,8.8a9.31,9.31,0,0,0,4.71.9,3.68,3.68,0,0,0,2.3-6.52,10,10,0,0,0-3.41-2.07c-7.61-3.17-15.76-3.25-23.77-1.33",
    style: {
      fill: "#5B5BF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.83,330.6c1.69.48,2.27,1.36,3.61,2.5a38.88,38.88,0,0,0,15.79,8.11c.6.15,1.39.2,1.69-.34s-.07-1.05-.41-1.48a21.84,21.84,0,0,0-9.53-6.47c-3.64-1.35-6.8-3-11.15-2.64",
    style: {
      fill: "#5B5BF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653,299a29.88,29.88,0,0,0,22.91,7.79,1.54,1.54,0,0,0,1-.37c.58-.63-.12-1.6-.79-2.12-6.73-5.25-14.89-7.43-23.16-5.3",
    style: {
      fill: "#5B5BF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.74,296.83a31.93,31.93,0,0,1,28.58-4.71,22.73,22.73,0,0,1-13.62,6,43.15,43.15,0,0,1-15-1.27",
    style: {
      fill: "#5B5BF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.44,282.29c-.66-6.72-.23-12-.7-18.78,0-.54-.15-1.19-.66-1.38-.7-.27-1.29.59-1.52,1.31a21.54,21.54,0,0,0,2.87,18.7",
    style: {
      fill: "#5B5BF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656,283a39.4,39.4,0,0,0,11.13-10.82c2.2-3,4-6.61,3.55-10.3a10.65,10.65,0,0,0-8,4,22.33,22.33,0,0,0-4.09,8.23c-.89,3-1.52,6-2.56,8.9",
    style: {
      fill: "#5B5BF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.89,280a89.74,89.74,0,0,0,27.4-16.16c-3.27-1.32-7-.53-10.29.79a32.46,32.46,0,0,0-17.25,15.29",
    style: {
      fill: "#5B5BF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659,286.71a56.15,56.15,0,0,0,15.21.08c4.94-.83,9.6-2.78,14.21-4.72a1.64,1.64,0,0,0,1-.74,1.11,1.11,0,0,0-.34-1.21,3,3,0,0,0-1.21-.57c-5-1.4-10.42-.74-15.35.92A71.35,71.35,0,0,0,659,286.71",
    style: {
      fill: "#5B5BF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.15,299.18c-3.45-7-3.23-15.09-.25-22.27,2.1,3.19,2.36,7.27,2,11.07s-1.54,7.72-1.61,11.55",
    style: {
      fill: "#5B5BF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.36,292.23a31,31,0,0,0-23.08,9.83,21.53,21.53,0,0,0,12.64-2.34,64.16,64.16,0,0,0,10.83-7.25",
    style: {
      fill: "#5B5BF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.1,289.13c-4.22-.34-8.27-.87-12.33.38a14.78,14.78,0,0,0-9.39,8,22.27,22.27,0,0,0,11.55-2.18,67.16,67.16,0,0,0,10.17-6.16",
    style: {
      fill: "#5B5BF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.82,289.27c-3.79-2.49-7.69-5-12.1-6s-9.53-.27-12.61,3c3.57,2.1,7.91,2.35,12,2.35s9.23-.05,13.13,1.33",
    style: {
      fill: "#5B5BF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.84,289.47c-6.48-6.37-8.94-17.8-6.33-26.5a40.38,40.38,0,0,1,6.33,26.5",
    style: {
      fill: "#5B5BF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.67,271.43c1.22-2.84,2.08-5.82,3.17-8.71a25.15,25.15,0,0,1,4.54-8,11.91,11.91,0,0,1,8-4.16,32.36,32.36,0,0,1-15.59,21",
    style: {
      fill: "#5B5BF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.44,275.19c-2-2.78-4.36-6.56-7.1-8.64s-6.32-3.34-9.67-2.54a22.5,22.5,0,0,0,16.77,11.18",
    style: {
      fill: "#5B5BF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.09,271.67a47.58,47.58,0,0,1-3.2-10.36,16.14,16.14,0,0,1,1.62-10.53c3.56,6.73,4.7,14,1.76,21",
    style: {
      fill: "#5B5BF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.7,250.78c2-6.67,8.12-11.58,14.71-13.83a5.59,5.59,0,0,1,2.58-.39,2.24,2.24,0,0,1,1.9,1.59c.24,1.13-.69,2.15-1.58,2.9a50.09,50.09,0,0,1-17.61,9.73",
    style: {
      fill: "#5B5BF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.77,245.33c.26-4.3.53-8.66,1.92-12.74s4.1-7.89,8-9.67c.67,4.34-1.25,8.66-3.56,12.39s-5.1,7.27-6.48,11.43",
    style: {
      fill: "#5B5BF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.67,248.29c-1.67-4.86-1.84-11-4.75-15.27-2-3-5.29-5-7-8.11a12.4,12.4,0,0,0,.41,9.21,26.64,26.64,0,0,0,5.39,7.7c2.15,2.3,4,4,6,6.47",
    style: {
      fill: "#5B5BF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.7,391.39c-.13,0-.24-32.41-.25-72.39s.09-72.41.22-72.41.24,32.41.25,72.41S638.83,391.39,638.7,391.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667,294.29a7.59,7.59,0,0,1-1.22.46l-3.36,1.13c-2.82,1-6.71,2.36-10.93,4.08s-8.11,3.25-10.35,5.19a7.63,7.63,0,0,0-2.08,2.76c-.32.76-.38,1.22-.42,1.21s0-.11,0-.34a5.14,5.14,0,0,1,.24-.94,7.25,7.25,0,0,1,2-2.93,18.11,18.11,0,0,1,4.49-2.8c1.8-.83,3.79-1.71,5.91-2.58,4.23-1.73,8.14-3.08,11-4,1.43-.44,2.6-.77,3.41-1A7,7,0,0,1,667,294.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.31,271.48a1.66,1.66,0,0,1-.34.36l-1,1-3.88,3.53-12.93,11.51c-5,4.49-9.4,8.78-12.42,12-1.52,1.62-2.71,2.95-3.52,3.88l-.94,1.08a2.19,2.19,0,0,1-.35.35s.08-.15.28-.41.48-.65.87-1.13c.77-1,1.93-2.35,3.41-4a164.79,164.79,0,0,1,12.36-12.14c5.06-4.48,9.67-8.51,13-11.41l4-3.42c.44-.36.81-.66,1.1-.91A2.15,2.15,0,0,1,676.31,271.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.68,292.42c-.14-.05.92-2.49,2-5.57s1.56-5.67,1.69-5.65a19.18,19.18,0,0,1-1.25,5.8,37.55,37.55,0,0,1-1.57,3.9A6.36,6.36,0,0,1,652.68,292.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.73,312.05a6,6,0,0,1-.78-.91l-2-2.55c-1.67-2.16-4-5.15-6.58-8.42s-5-6.19-6.7-8.31l-2-2.52a6.71,6.71,0,0,1-.7-1,5.66,5.66,0,0,1,.84.84c.52.56,1.25,1.39,2.15,2.42,1.79,2.07,4.22,5,6.82,8.24s4.87,6.3,6.47,8.51c.81,1.11,1.45,2,1.88,2.65A6.21,6.21,0,0,1,638.73,312.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.52,304.07a11.34,11.34,0,0,1-2.61-4.87,14.14,14.14,0,0,1-.59-4.91l.21,0c-.09.37-.16.57-.2.56s0-.21,0-.6l.2,0a22.94,22.94,0,0,0,.83,4.78A35.43,35.43,0,0,0,632.52,304.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.5,294a9.1,9.1,0,0,0-1.82-1.05,12.15,12.15,0,0,0-5-.4,30.8,30.8,0,0,0-5.08.82,16.37,16.37,0,0,1-2.09.5,6.91,6.91,0,0,1,2-.82,23.21,23.21,0,0,1,5.13-1,11,11,0,0,1,5.2.56A3.22,3.22,0,0,1,624.5,294Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.6,291.54c0,.07-1.06-.42-2.79-1a28,28,0,0,0-14-1.07c-1.8.32-2.88.65-2.91.58a2.75,2.75,0,0,1,.74-.32,18.36,18.36,0,0,1,2.1-.59,24.87,24.87,0,0,1,14.21,1.08,17.36,17.36,0,0,1,2,.91A2.61,2.61,0,0,1,622.6,291.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.67,281.2a55.31,55.31,0,0,1-2-7.05,56,56,0,0,1-1.58-7.17,57.85,57.85,0,0,1,2,7.06A58.24,58.24,0,0,1,638.67,281.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.8,281.2a35.77,35.77,0,0,0-2.25-4.22,18.87,18.87,0,0,0-3.32-3.42,3.14,3.14,0,0,1,1.28.66,10.29,10.29,0,0,1,2.42,2.49A9.49,9.49,0,0,1,638.8,281.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.7,374.11c-.05,0-.15-.78-.51-2.15a30.45,30.45,0,0,0-2.17-5.62,77.71,77.71,0,0,0-11.49-16.19c-2.57-2.93-5.06-5.7-7.17-8.34a58.65,58.65,0,0,1-5.13-7.4,36.54,36.54,0,0,1-2.59-5.48c-.23-.68-.41-1.21-.5-1.57a3.11,3.11,0,0,1-.14-.56s.28.74.81,2.06a41.34,41.34,0,0,0,2.71,5.39,63.15,63.15,0,0,0,5.17,7.29c2.13,2.62,4.62,5.37,7.19,8.3,5.19,5.83,9.26,11.71,11.44,16.36a27.74,27.74,0,0,1,2,5.71,14.78,14.78,0,0,1,.29,1.63A3,3,0,0,1,638.7,374.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.3,345.2A14.86,14.86,0,0,1,663,346a29.74,29.74,0,0,0-3.48,2.3,39.35,39.35,0,0,0-4.57,4.17c-1.61,1.7-3.26,3.66-4.95,5.77-3.37,4.23-6.52,8-8.41,11-1,1.49-1.66,2.74-2.11,3.61a10.89,10.89,0,0,1-.74,1.35s0-.13.12-.38.24-.6.45-1.05a34.57,34.57,0,0,1,2-3.7,118.87,118.87,0,0,1,8.33-11.08c1.69-2.11,3.36-4.09,5-5.78a37.28,37.28,0,0,1,4.69-4.13,24.94,24.94,0,0,1,3.59-2.2c.45-.22.81-.36,1-.46S664.29,345.18,664.3,345.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.8,354.58A19.18,19.18,0,0,1,662,355a37.53,37.53,0,0,0-6.72,1.33,19.85,19.85,0,0,0-6,3.16c-1.39,1.07-2.05,2-2.11,1.9a2.33,2.33,0,0,1,.42-.65,10.08,10.08,0,0,1,1.48-1.51,18.16,18.16,0,0,1,6.08-3.35,30,30,0,0,1,6.84-1.21A15.4,15.4,0,0,1,664.8,354.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.94,360.35c-.15-.08,1.13-2,2.12-4.66s1.15-5,1.31-4.94a4.5,4.5,0,0,1,0,1.52,17,17,0,0,1-.83,3.58,17.53,17.53,0,0,1-1.65,3.29C648.35,359.93,648,360.39,647.94,360.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.59,320a3.54,3.54,0,0,1-.46.24l-1.33.6c-.58.25-1.29.57-2.09,1s-1.73.84-2.71,1.43l-1.55.88c-.53.3-1.06.67-1.63,1-1.14.7-2.28,1.55-3.5,2.42A65.38,65.38,0,0,0,652,334a66.94,66.94,0,0,0-6.18,7.52c-.83,1.25-1.64,2.42-2.29,3.59-.33.57-.68,1.12-1,1.66s-.56,1.08-.83,1.58c-.55,1-.94,1.94-1.33,2.76s-.69,1.53-.92,2.12-.41,1-.56,1.35a2.19,2.19,0,0,1-.22.46,1.75,1.75,0,0,1,.14-.49c.12-.37.28-.82.47-1.39s.48-1.33.85-2.16.74-1.79,1.27-2.8l.81-1.6c.28-.55.63-1.1,1-1.69.65-1.18,1.45-2.37,2.28-3.63a62.91,62.91,0,0,1,6.19-7.61,65.12,65.12,0,0,1,7.39-6.45c1.24-.87,2.4-1.71,3.55-2.39.58-.35,1.12-.71,1.66-1s1.07-.58,1.57-.86c1-.56,1.94-1,2.76-1.36a21.75,21.75,0,0,1,2.13-.92l1.37-.53A1.48,1.48,0,0,1,672.59,320Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.33,333.59a3.25,3.25,0,0,1,1.11-1.66,7.07,7.07,0,0,1,4.49-1.72,12.37,12.37,0,0,1,4.72.92,6.89,6.89,0,0,1,1.79.87,10.27,10.27,0,0,1-1.89-.55,14.1,14.1,0,0,0-4.6-.77,7.27,7.27,0,0,0-4.29,1.5A13,13,0,0,0,652.33,333.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.3,336.71a12,12,0,0,0,1-8.47,2.76,2.76,0,0,1,.53,1.21,8.57,8.57,0,0,1,.22,3.17,8.45,8.45,0,0,1-.95,3C649.69,336.38,649.35,336.75,649.3,336.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.31,378.76c.7,12.39,4.43,25,10.17,37.72h25c5.48-12.61,8.95-25.19,9.57-37.72Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657,398.8c0,.13-8.23.24-18.37.24s-18.36-.11-18.36-.24,8.22-.23,18.36-.23S657,398.68,657,398.8Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.42,403.29c0,.13-7.71.24-17.22.24s-17.21-.11-17.21-.24,7.71-.23,17.21-.23S656.42,403.16,656.42,403.29Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 175.89,
    y: 156.3,
    width: 384.52,
    height: 254.28,
    rx: 14.57,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.86,394.16H577.46a0,0,0,0,1,0,0v4.45a17.8,17.8,0,0,1-17.8,17.8h-381a17.8,17.8,0,0,1-17.8-17.8v-4.45a0,0,0,0,1,0,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.21,
    y: 166.4,
    width: 362.8,
    height: 214.73,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "330.25 391.77 335.41 400 408.16 400 412.96 391.77 330.25 391.77",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.69,
    y: 173.67,
    width: 348.6,
    height: 206.78,
    rx: 3.27,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "541.91 380.75 193.31 380.75 193.69 189.13 541.91 189.13 541.91 380.75",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.28,181.66a2.79,2.79,0,1,1-2.79-2.78A2.78,2.78,0,0,1,222.28,181.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.4,181.66a2.79,2.79,0,1,1-2.78-2.78A2.77,2.77,0,0,1,205.4,181.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.5,181.66a2.79,2.79,0,1,1-2.78-2.78A2.77,2.77,0,0,1,213.5,181.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.1,391.77c0,.14-85.34.25-190.59.25s-190.62-.11-190.62-.25,85.33-.25,190.62-.25S557.1,391.64,557.1,391.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "305.31 263.98 447.14 262.66 451.29 359.07 304.43 358.02 305.31 263.98",
    style: {
      fill: "#5B5BF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.31,264l67-54.45a7.72,7.72,0,0,1,9.74,0l65.08,53.12",
    style: {
      fill: "#5B5BF0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M305.31,264l67-54.45a7.72,7.72,0,0,1,9.74,0l65.08,53.12"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M304.43,358c-.17-.17,11.15-12.59,25.3-27.74S355.5,303,355.68,303.14s-11.15,12.58-25.31,27.74S304.61,358.18,304.43,358Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.29,359.07c-.18.17-11.26-12-24.75-27.07s-24.28-27.5-24.1-27.66,11.26,12,24.76,27.08S451.47,358.91,451.29,359.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "447.14 262.66 376.04 319.7 305.31 263.98"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "312.47 269.24 312.15 224.94 436.34 223.22 437.83 269.82 376.03 318.95 312.47 269.24",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.47,269.24s.41.29,1.18.88l3.38,2.61,12.86,10c11.08,8.65,27,21,46.27,36.08h-.26l61.77-49.17-.09.21c-.29-8.89-.59-18.22-.89-27.71-.21-6.39-.41-12.71-.61-18.9l.26.25-124.18,1.64.16-.17c.06,13.93.12,25,.15,32.58,0,3.79,0,6.71,0,8.7,0,1,0,1.73,0,2.25s0,.77,0,.77,0-.25,0-.75,0-1.26,0-2.23c0-2-.06-4.9-.1-8.68-.07-7.61-.18-18.68-.31-32.64v-.16h.16L436.33,223h.26v.26c.2,6.19.4,12.5.61,18.89.3,9.49.6,18.82.88,27.71v.13l-.1.08-61.84,49.1-.13.11-.13-.11-46.22-36.27-12.76-10.06-3.33-2.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.76,245.56c0,.14-19,.41-42.42.6s-42.42.23-42.42.09,19-.41,42.42-.61S416.76,245.41,416.76,245.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.78,258.07c0,.14-19,.42-42.41.61s-42.42.23-42.42.08,19-.41,42.42-.6S416.78,257.93,416.78,258.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.81,272.49c0,.15-19,.42-42.41.61s-42.42.23-42.42.08,19-.41,42.42-.6S416.81,272.35,416.81,272.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.84,286.91c0,.15-18.11.41-40.46.59s-40.47.22-40.47.07,18.11-.41,40.47-.59S416.84,286.77,416.84,286.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401,299.6a1.65,1.65,0,0,1-.5.06l-1.43.06-5.24.13-17.31.32c-6.76.12-12.89.16-17.32.16l-5.24,0-1.43,0a2,2,0,0,1-.5-.05,1.65,1.65,0,0,1,.5-.06l1.42-.06,5.25-.13,17.31-.31c6.76-.13,12.88-.17,17.31-.17l5.25,0,1.43,0A2.55,2.55,0,0,1,401,299.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385,311.8a76.73,76.73,0,0,1-9,.28,77.38,77.38,0,0,1-9-.24,79.42,79.42,0,0,1,9-.28A80.12,80.12,0,0,1,385,311.8Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M709,415.55c0,.15-149.54.26-334,.26s-334-.11-334-.26,149.51-.26,334-.26S709,415.41,709,415.55Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--envelope-3--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M401.76,222.83c.14,0,.2.58.13,1.27s-.24,1.23-.38,1.22-.2-.59-.13-1.28S401.61,222.81,401.76,222.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.09,213.09a6.09,6.09,0,0,1-.11,2.46,6.18,6.18,0,0,1-.63,2.39,11.6,11.6,0,0,1,.74-4.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.05,203.45a6,6,0,0,1-.27,2.46,6.14,6.14,0,0,1-.79,2.34,5.91,5.91,0,0,1,.28-2.45A6,6,0,0,1,405.05,203.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.72,194a11.53,11.53,0,0,1-1.43,4.71,6.14,6.14,0,0,1,.47-2.43A5.88,5.88,0,0,1,407.72,194Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.15,184.78a6.15,6.15,0,0,1-.67,2.38,6,6,0,0,1-1.15,2.19A6.19,6.19,0,0,1,410,187,5.92,5.92,0,0,1,411.15,184.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.41,175.93a11.85,11.85,0,0,1-2.24,4.37,6,6,0,0,1,.89-2.3C414.68,176.79,415.28,175.86,415.41,175.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.55,167.55a6.12,6.12,0,0,1-1.15,2.19c-.72,1.14-1.41,2-1.53,1.93a5.81,5.81,0,0,1,1.09-2.22C419.72,168.32,420.43,167.47,420.55,167.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.61,159.81a6.23,6.23,0,0,1-1.37,2.06c-.87,1-1.66,1.81-1.78,1.72s.5-1,1.38-2.05S426.5,159.72,426.61,159.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.53,152.84c.1.11-.62.95-1.6,1.88s-1.86,1.6-2,1.5.61-.94,1.6-1.88S433.44,152.73,433.53,152.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.27,146.78c.08.12-.74.87-1.83,1.67a6.06,6.06,0,0,1-2.13,1.24c-.09-.11.73-.86,1.83-1.66A5.9,5.9,0,0,1,441.27,146.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.75,141.81a11.7,11.7,0,0,1-4.33,2.34c-.07-.13.84-.75,2-1.4A5.91,5.91,0,0,1,449.75,141.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.85,138.11a6.24,6.24,0,0,1-2.22,1.08,5.93,5.93,0,0,1-2.4.59,6.09,6.09,0,0,1,2.22-1.08A5.77,5.77,0,0,1,458.85,138.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.41,135.88a6.2,6.2,0,0,1-2.37.66,6,6,0,0,1-2.45.25,9.83,9.83,0,0,1,4.82-.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.22,135.34a6.08,6.08,0,0,1-2.45.28,5.85,5.85,0,0,1-2.46-.23,6.1,6.1,0,0,1,2.45-.29A5.84,5.84,0,0,1,478.22,135.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488,136.49a6.07,6.07,0,0,1-2.47-.14,5.94,5.94,0,0,1-2.39-.65,11.87,11.87,0,0,1,4.86.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.39,139.3a11.61,11.61,0,0,1-4.65-1.62,6.32,6.32,0,0,1,2.41.56A5.91,5.91,0,0,1,497.39,139.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.14,143.76a6.23,6.23,0,0,1-2.26-1,6.06,6.06,0,0,1-2-1.45,6,6,0,0,1,2.26,1C505.32,143,506.22,143.64,506.14,143.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.84,149.84a6.27,6.27,0,0,1-2-1.43c-1-.88-1.76-1.7-1.67-1.81s1,.52,2,1.42S513.94,149.74,513.84,149.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.7,155.44c-.12.08-.55-.29-1-.83s-.67-1.05-.56-1.15.54.28,1,.83S518.82,155.35,518.7,155.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.94,215.69a6.13,6.13,0,0,1-2.37-.82c-1.26-.58-2.23-1.16-2.16-1.29a6.52,6.52,0,0,1,2.38.82A6.28,6.28,0,0,1,564.94,215.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.38,219a12.16,12.16,0,0,1-4.78-1.46,12,12,0,0,1,4.78,1.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.25,220.55a6.18,6.18,0,0,1-2.52,0,6.1,6.1,0,0,1-2.45-.53,6.38,6.38,0,0,1,2.51,0A6.29,6.29,0,0,1,584.25,220.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.23,220.24a6.2,6.2,0,0,1-2.47.44,6,6,0,0,1-2.52-.07,6.56,6.56,0,0,1,2.48-.45A6.1,6.1,0,0,1,594.23,220.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.05,218.4a6.42,6.42,0,0,1-2.37.84,6.27,6.27,0,0,1-2.51.25,6.29,6.29,0,0,1,2.4-.75A6.1,6.1,0,0,1,604.05,218.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.33,214.71c.07.13-.9.7-2.16,1.29a6,6,0,0,1-2.38.8,12.16,12.16,0,0,1,4.54-2.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.62,209.14c.09.11-.69.93-1.8,1.77a5.52,5.52,0,0,1-2.19,1.24c-.08-.12.78-.83,1.88-1.65A7,7,0,0,1,621.62,209.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.42,201.84a5.56,5.56,0,0,1-1.33,2.15c-.89,1.07-1.75,1.81-1.85,1.71s.58-1,1.45-2S628.3,201.76,628.42,201.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.1,193a5.34,5.34,0,0,1-.69,2.43,5.56,5.56,0,0,1-1.34,2.14,7.37,7.37,0,0,1,.86-2.36A7.59,7.59,0,0,1,633.1,193Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635,183.26a5.28,5.28,0,0,1,.11,2.52,5.18,5.18,0,0,1-.62,2.45,7.78,7.78,0,0,1,.1-2.5A7.6,7.6,0,0,1,635,183.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.51,173.4a5.45,5.45,0,0,1,.9,2.36,5.32,5.32,0,0,1,.21,2.51,7.43,7.43,0,0,1-.72-2.39A7.59,7.59,0,0,1,633.51,173.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.16,164.44c.11-.09.87.77,1.57,2a5.2,5.2,0,0,1,.94,2.33c-.13.07-.71-.89-1.39-2.07A7.72,7.72,0,0,1,629.16,164.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.22,157.3a5.22,5.22,0,0,1,2.13,1.36c1.06.91,1.75,1.81,1.65,1.91s-1-.63-2-1.52S622.14,157.42,622.22,157.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.15,153.24a5,5,0,0,1,2.5.41,5.18,5.18,0,0,1,2.25,1.15,7.82,7.82,0,0,1-2.41-.66A8.19,8.19,0,0,1,613.15,153.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.24,153.41a4.83,4.83,0,0,1,2.42-.73,5,5,0,0,1,2.53.08,26.92,26.92,0,0,1-5,.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.62,158.23c-.11-.09.58-1,1.71-1.87a4.71,4.71,0,0,1,2.26-1.15c.07.14-.87.75-2,1.57S594.73,158.33,594.62,158.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.66,167.21a4.57,4.57,0,0,1,.15-2.53,4.42,4.42,0,0,1,1.05-2.31,10.86,10.86,0,0,1-.55,2.43A9.63,9.63,0,0,1,590.66,167.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.61,176.9a4.86,4.86,0,0,1-1.21-2.22,4.72,4.72,0,0,1-.42-2.5,9,9,0,0,1,.91,2.33A8.62,8.62,0,0,1,592.61,176.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.15,184.34A5,5,0,0,1,597,183c-1.06-.92-1.71-1.86-1.6-1.95s.92.66,1.94,1.56S599.23,184.22,599.15,184.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.23,188.41a5.28,5.28,0,0,1-2.48-.47,5.06,5.06,0,0,1-2.25-1.15,7.82,7.82,0,0,1,2.41.66A7.4,7.4,0,0,1,608.23,188.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.15,189.35a9.23,9.23,0,0,1-5-.11,7.9,7.9,0,0,1,2.5-.12A7.28,7.28,0,0,1,618.15,189.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628,187.53a9.36,9.36,0,0,1-4.84,1.24,7.13,7.13,0,0,1,2.37-.79A7.63,7.63,0,0,1,628,187.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637,183.38a6.27,6.27,0,0,1-2.09,1.4,6.2,6.2,0,0,1-2.33.94,12.18,12.18,0,0,1,4.42-2.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645,177.42c.1.11-.69.91-1.76,1.79a6.49,6.49,0,0,1-2.1,1.39c-.09-.12.71-.92,1.77-1.79A6.58,6.58,0,0,1,645,177.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.85,170.11c.11.09-.53,1-1.43,2.07s-1.72,1.83-1.82,1.73.53-1,1.42-2.07S651.73,170,651.85,170.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.34,161.77a6.14,6.14,0,0,1-1.06,2.28c-.72,1.19-1.39,2.09-1.51,2a6.19,6.19,0,0,1,1.06-2.28C656.54,162.6,657.21,161.7,657.34,161.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.4,152.63a6.44,6.44,0,0,1-.67,2.43,5.66,5.66,0,0,1-1.18,2.22,7.14,7.14,0,0,1,.69-2.41A6.29,6.29,0,0,1,661.4,152.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.19,143a6.07,6.07,0,0,1-.37,2.48,6.26,6.26,0,0,1-.88,2.36,11.95,11.95,0,0,1,1.25-4.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.94,133.2a6,6,0,0,1-.12,2.51,6.31,6.31,0,0,1-.63,2.43,6,6,0,0,1,.12-2.51A6.38,6.38,0,0,1,665.94,133.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.86,123.24a11.93,11.93,0,0,1-.37,5,6.47,6.47,0,0,1-.07-2.52A6.31,6.31,0,0,1,666.86,123.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.18,113.25a6,6,0,0,1,.21,2.5,6,6,0,0,1-.31,2.5,6.55,6.55,0,0,1-.21-2.51A6.39,6.39,0,0,1,667.18,113.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.11,103.25a6.27,6.27,0,0,1,.3,2.5,6,6,0,0,1-.23,2.5,6.31,6.31,0,0,1-.3-2.5A6.43,6.43,0,0,1,667.11,103.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667,97.1c.14,0,.27.25.28.57s-.1.57-.25.58-.27-.25-.27-.57S666.82,97.1,667,97.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 623.19,
    y: 70.99,
    width: 68.37,
    height: 46.09,
    transform: "translate(-6.31 71.52) rotate(-6.2)",
    style: {
      fill: "#5B5BF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.85,120.66v0l-5-45.84h0l68-7.38v0l5,45.85h0Zm-4.92-45.82,5,45.77,67.92-7.38-5-45.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.15,68a4.68,4.68,0,0,1-.57.68l-1.71,1.87-6.39,6.78L659.19,99.55l-.17.19-.22-.14-.52-.33L632,82.46,624,77.31l-2.14-1.43a5.91,5.91,0,0,1-.73-.53,4.5,4.5,0,0,1,.8.42l2.2,1.33,8,5,26.41,16.66.52.33-.39,0L680.17,77l6.53-6.64,1.79-1.78A4.87,4.87,0,0,1,689.15,68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.15,121.16c-.14-.09,4.29-6.93,9.89-15.26s10.27-15,10.41-14.92-4.28,6.93-9.89,15.26S626.29,121.26,626.15,121.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669,88c.13-.12,5.86,5.57,12.8,12.7s12.47,13,12.35,13.13-5.85-5.56-12.8-12.7S668.86,88.07,669,88Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--envelope-2--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M378.47,206.35c.14,0,.35.51.47,1.19s.09,1.25-.05,1.28-.35-.51-.47-1.2S378.33,206.37,378.47,206.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.87,196.59a6.2,6.2,0,0,1,.65,2.4,6.11,6.11,0,0,1,.14,2.48,5.94,5.94,0,0,1-.65-2.4A6.11,6.11,0,0,1,376.87,196.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.44,186.81a6,6,0,0,1,.6,2.41,6.17,6.17,0,0,1,.09,2.48,5.84,5.84,0,0,1-.6-2.41A6.17,6.17,0,0,1,375.44,186.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.32,177a6.22,6.22,0,0,1,.52,2.43,5.88,5.88,0,0,1,0,2.48,6.12,6.12,0,0,1-.51-2.43A6,6,0,0,1,374.32,177Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.63,167.12a11.89,11.89,0,0,1,.28,4.94,11.87,11.87,0,0,1-.28-4.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.53,157.23a12.14,12.14,0,0,1,0,5,5.85,5.85,0,0,1-.25-2.47A6,6,0,0,1,373.53,157.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.15,147.37a6.33,6.33,0,0,1,.05,2.49,6.14,6.14,0,0,1-.46,2.44,5.93,5.93,0,0,1-.06-2.48A6.06,6.06,0,0,1,374.15,147.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.63,137.6a5.84,5.84,0,0,1-.17,2.48,6,6,0,0,1-.69,2.39,12.16,12.16,0,0,1,.86-4.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.16,128.05a6.27,6.27,0,0,1-.46,2.44,6.34,6.34,0,0,1-.95,2.3,6,6,0,0,1,.45-2.45A5.88,5.88,0,0,1,378.16,128.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.85,118.88a6.06,6.06,0,0,1-.76,2.37,6.21,6.21,0,0,1-1.23,2.16,12,12,0,0,1,2-4.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.67,110.26a6.17,6.17,0,0,1-1.05,2.25c-.7,1.16-1.37,2-1.5,2a6.18,6.18,0,0,1,1.06-2.25C385.88,111.07,386.55,110.18,386.67,110.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.6,102.35c.11.1-.49,1-1.34,2.09s-1.64,1.85-1.76,1.76a6.26,6.26,0,0,1,1.35-2.09C391.71,103.05,392.5,102.26,392.6,102.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.63,95.4c.09.12-.65.95-1.65,1.87s-1.9,1.57-2,1.47.64-.93,1.65-1.86S399.54,95.29,399.63,95.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.71,89.72c.07.13-.8.82-1.95,1.55a6.09,6.09,0,0,1-2.22,1.11c-.08-.11.79-.81,1.94-1.55A6.34,6.34,0,0,1,407.71,89.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.71,85.67a6,6,0,0,1-2.21,1.14,6.05,6.05,0,0,1-2.39.66,6.08,6.08,0,0,1,2.21-1.14A6,6,0,0,1,416.71,85.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.93,83.89c0,.14-.5.36-1.17.49s-1.25.12-1.28,0,.5-.36,1.18-.49S423.91,83.75,423.93,83.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 371.32,
    y: 45.95,
    width: 50.11,
    height: 74.34,
    transform: "translate(175.89 422.84) rotate(-68.86)",
    style: {
      fill: "#5B5BF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422,119.93h0L352.64,93.1v0l18.09-46.76h0l69.36,26.82v0ZM352.7,93.07,422,119.86l18.06-46.69-69.3-26.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.08,73.81a4.77,4.77,0,0,1-.88.37l-2.59.94-9.55,3.36L395.38,89.36l-.26.09-.14-.24-.34-.58-17-29.37-5.09-8.94-1.35-2.45a5,5,0,0,1-.44-.88,5.53,5.53,0,0,1,.55.81l1.47,2.39L378,59c4.44,7.54,10.5,17.87,17.19,29.27l.34.58-.4-.15L426.91,78l9.62-3.15,2.63-.83A4.38,4.38,0,0,1,440.08,73.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.67,93.73c-.09-.16,7.6-4.55,17.18-9.8s17.41-9.38,17.5-9.22-7.6,4.55-17.18,9.81S352.76,93.89,352.67,93.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.63,83c.18-.05,2.87,8.3,6,18.65s5.55,18.8,5.37,18.85-2.87-8.29-6-18.65S410.45,83.09,410.63,83Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--envelope-1--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M349.35,217.29c.14,0,.21.58.16,1.27s-.22,1.24-.36,1.23-.22-.58-.16-1.27S349.21,217.28,349.35,217.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.6,207.12a6.33,6.33,0,0,1,.26,2.55,6.55,6.55,0,0,1-.27,2.54,6.41,6.41,0,0,1-.25-2.54A6.63,6.63,0,0,1,349.6,207.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.91,197a12.78,12.78,0,0,1,.47,5.07,6.17,6.17,0,0,1-.49-2.51A6.61,6.61,0,0,1,348.91,197Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.22,186.94a6.51,6.51,0,0,1,.74,2.45,6.44,6.44,0,0,1,.23,2.55,6.59,6.59,0,0,1-.74-2.45A6.22,6.22,0,0,1,347.22,186.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.45,177.15A12.48,12.48,0,0,1,346,182a6.42,6.42,0,0,1-1-2.35A6.35,6.35,0,0,1,344.45,177.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.56,167.76a6.32,6.32,0,0,1,1.28,2.21,6.54,6.54,0,0,1,.81,2.43,6.57,6.57,0,0,1-1.28-2.21A6.43,6.43,0,0,1,340.56,167.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.51,158.93c.12-.08.84.82,1.6,2a6.65,6.65,0,0,1,1.08,2.33c-.13.07-.81-.85-1.53-2.06A6.45,6.45,0,0,1,335.51,158.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.28,150.9c.11-.1.93.7,1.83,1.78a6.58,6.58,0,0,1,1.43,2.13c-.12.08-.93-.72-1.83-1.79A6.49,6.49,0,0,1,329.28,150.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322,143.82c.09-.11,1,.57,2.06,1.51s1.81,1.8,1.71,1.9a6.51,6.51,0,0,1-2.06-1.51C322.65,144.78,321.88,143.93,322,143.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.73,137.88a6.34,6.34,0,0,1,2.26,1.19c1.17.78,2.06,1.51,2,1.63a6.62,6.62,0,0,1-2.26-1.2C314.54,138.73,313.65,138,313.73,137.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.67,133.26a6.35,6.35,0,0,1,2.42.83,6.43,6.43,0,0,1,2.2,1.3,6.35,6.35,0,0,1-2.42-.83A6.56,6.56,0,0,1,304.67,133.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295,130.19a6.59,6.59,0,0,1,2.53.41,6.4,6.4,0,0,1,2.39.92,6.75,6.75,0,0,1-2.53-.41A6.6,6.6,0,0,1,295,130.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.89,128.9a10.39,10.39,0,0,1,5.07.41,15.84,15.84,0,0,1-5.07-.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.75,129.6a12.53,12.53,0,0,1,5.06-.6,6.34,6.34,0,0,1-2.5.56A6.66,6.66,0,0,1,274.75,129.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.93,132.22a6.32,6.32,0,0,1,2.35-1,6.25,6.25,0,0,1,2.5-.52,6.53,6.53,0,0,1-2.35,1A6.64,6.64,0,0,1,264.93,132.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.77,136.63c-.07-.13.87-.77,2.12-1.44a6.32,6.32,0,0,1,2.36-1,12.86,12.86,0,0,1-4.48,2.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.65,142.73c-.1-.1.7-.92,1.78-1.83a6.58,6.58,0,0,1,2.13-1.43c.08.12-.72.94-1.79,1.83A6.28,6.28,0,0,1,247.65,142.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241,150.41a5.73,5.73,0,0,1,1.29-2.22c.87-1.12,1.72-1.9,1.82-1.81s-.55,1-1.41,2.13S241.12,150.49,241,150.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.29,157c-.13-.06,0-.61.31-1.24s.65-1.08.78-1,0,.62-.31,1.24S237.42,157.07,237.29,157Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.75,216c0-.14.53-.32,1.21-.41s1.25,0,1.27.11-.51.33-1.21.41S173.76,216.17,173.75,216Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.85,214.9a7.91,7.91,0,0,1,2.48.37,7.73,7.73,0,0,1,2.42.66,8.57,8.57,0,0,1-4.9-1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.89,210.47a7.54,7.54,0,0,1,2.24,1.14c1.18.7,2.13,1.29,2.07,1.43a5.58,5.58,0,0,1-2.33-1C155.67,211.34,154.81,210.59,154.89,210.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.45,203.79c.11-.09.93.67,1.9,1.65s1.72,1.81,1.63,1.92-1-.56-2-1.55S147.34,203.89,147.45,203.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.57,195.69c.13-.07.84.8,1.59,2a6.42,6.42,0,0,1,1.16,2.23c-.12.09-.83-.79-1.59-1.95A6.18,6.18,0,0,1,141.57,195.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.25,186.66a6.28,6.28,0,0,1,1.22,2.2,6.65,6.65,0,0,1,.75,2.41,6.21,6.21,0,0,1-1.23-2.2A6.39,6.39,0,0,1,137.25,186.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.38,177.06a6.36,6.36,0,0,1,.89,2.36,6.2,6.2,0,0,1,.38,2.49,6.08,6.08,0,0,1-.89-2.36A6.22,6.22,0,0,1,134.38,177.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.64,167.19a6.54,6.54,0,0,1,.63,2.44,6.29,6.29,0,0,1,.12,2.52,6.19,6.19,0,0,1-.63-2.44A6.08,6.08,0,0,1,132.64,167.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.68,157.22a12.12,12.12,0,0,1,.4,5,6.2,6.2,0,0,1-.46-2.47A6.1,6.1,0,0,1,131.68,157.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.26,149.71c.15,0,.29.55.32,1.24s-.06,1.25-.2,1.26-.29-.55-.32-1.24S131.12,149.72,131.26,149.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.04,
    y: 91.01,
    width: 83.24,
    height: 56.11,
    transform: "translate(-5.46 6.19) rotate(-2.7)",
    style: {
      fill: "#5B5BF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.38,149.07v0L85.74,93h0l83.18-3.92v0l2.64,56.07h0ZM85.79,93l2.64,56,83.1-3.92-2.64-56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.21,89.74a5.48,5.48,0,0,1-.74.78l-2.22,2.14L158,100.43,130.46,125.9l-.23.21-.25-.18-.6-.44L98.65,103.11c-3.86-2.86-7-5.19-9.26-6.85l-2.49-1.9a5.48,5.48,0,0,1-.84-.7,6.86,6.86,0,0,1,.93.58L89.57,96l9.4,6.66,30.85,22.2.61.44-.48,0L157.63,100l8.42-7.59,2.32-2A5.14,5.14,0,0,1,169.21,89.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.7,149.71c-.16-.13,5.73-8.11,13.16-17.82s13.59-17.48,13.75-17.36-5.72,8.11-13.15,17.82S88.87,149.83,88.7,149.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.22,112.53c.16-.14,6.7,7.2,14.6,16.38s14.19,16.74,14,16.88-6.69-7.2-14.6-16.39S143.06,112.67,143.22,112.53Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M234.57,288.16a2.27,2.27,0,0,0-1.72-2.53l-2.23.15-8-2.77a2.39,2.39,0,0,0-3,2.17c0,2.29-1,8.53-2.81,6.57l-.14-.13c-2.63-2.93-5.67-4.35-6.84-4.18a1.34,1.34,0,0,0-.58,2.36,1.41,1.41,0,0,0,.48.33c.08,0,.18.1.26.14a20.21,20.21,0,0,1,3.05,2.73,10.6,10.6,0,0,1,2,3c.53,1.24.95,2.32,1.28,3.25l.12,7.33-3.18,34.27s-21.1-22.16-20.61-22.37L193.88,353l12.78,10.57A16.07,16.07,0,0,0,233,350.92l-.73-44.31.52-5.81Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.11,336.88,93,389.72,74.76,427.84,61.19,432.4s-10.74,3.12-10.74,5.34,2.83,1.72,2.83,1.72c.52,3.32,5.12,1.44,8.34,0S72,437.62,72,437.62a2.91,2.91,0,0,0-.2,4.66c1.14.8,3.12-.17,4.46-1.6s4.8-2.09,8.65-3.47,4.48-6.54,4.48-6.54L135.6,352.8Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.75,356.07l5.81,7.67,12.59-27.93s-12.22-14.91-16.69-21.16-7.75-7.28-7.75-7.28S178.59,305,174.54,305l-20.06,1.2-20.37,8.89a28.22,28.22,0,0,0-12.27,10.33l-19.18,30.81,27.16,11.61L138.93,420c1.74,7.81,3.27,15.18,10.48,18.78l50.37-48.41-5.9-9.3Z",
    style: {
      fill: "#5B5BF0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.59,346.52c.12.08-3,4.9-6.93,10.78s-7.25,10.56-7.36,10.48,3-4.9,6.93-10.78S144.47,346.44,144.59,346.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.82,396a9.38,9.38,0,0,1-1.34.8c-.87.48-2.15,1.16-3.74,2-3.19,1.65-7.61,3.86-12.56,6.19s-9.47,4.34-12.77,5.74c-1.65.7-3,1.26-3.92,1.63a9.79,9.79,0,0,1-1.47.52,8.81,8.81,0,0,1,1.39-.71l3.85-1.77c3.26-1.49,7.76-3.55,12.7-5.88s9.39-4.49,12.61-6l3.82-1.84A9.17,9.17,0,0,1,186.82,396Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143,335.24a17.83,17.83,0,0,1-1.77-2.23,35.61,35.61,0,0,0-4.47-5.1,15.79,15.79,0,0,0-5.77-3.39c-1.65-.52-2.75-.5-2.75-.6a2,2,0,0,1,.77-.06,9.88,9.88,0,0,1,2.08.3,14.71,14.71,0,0,1,6,3.36,28.75,28.75,0,0,1,4.42,5.28A14.31,14.31,0,0,1,143,335.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.42,360.61a2.07,2.07,0,0,1,0,.56c0,.36,0,.89,0,1.58a36.9,36.9,0,0,1-.81,5.77,41.34,41.34,0,0,1-23.27,29,38,38,0,0,1-5.46,2c-.66.2-1.19.31-1.54.39a2.2,2.2,0,0,1-.54.1s.72-.25,2-.68a44.81,44.81,0,0,0,5.36-2.18,42.32,42.32,0,0,0,23.08-28.77,46.33,46.33,0,0,0,1-5.71C184.33,361.37,184.38,360.61,184.42,360.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M133.34,388c-.09-.5,6.46-34.36,6.46-34.36l-9.88,14.83"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M191.46,323.57a2.45,2.45,0,0,1,.07.58c0,.44.06,1,.11,1.68.07,1.52.18,3.6.31,6.15.25,5.26.6,12.41,1,20.3s.68,15.12.83,20.32c.08,2.6.13,4.71.15,6.16v1.68a2.17,2.17,0,0,1,0,.58,2.45,2.45,0,0,1-.07-.58c0-.44-.06-1-.11-1.67-.07-1.52-.18-3.61-.31-6.15-.25-5.26-.6-12.41-1-20.31s-.67-15.11-.83-20.32c-.08-2.6-.13-4.7-.15-6.16v-1.67A2.23,2.23,0,0,1,191.46,323.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M151.26,412.79c-1.62-1.34-1.25-4.08.18-5.62S155,405,157,404.32c9.57-3.1,19.19-7.48,25.5-15.32a15.45,15.45,0,0,1,2.83-3,3.91,3.91,0,0,1,3.93-.54c1.93,1,2,3.8,1.19,5.83a11.18,11.18,0,0,1-5.27,5.76"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "191.67 329.58 197.26 362.02 192.9 356.27 191.67 329.58"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M244.85,414.79l-9.45,32.42,40.27,12c.91-3.92-17.63-17.83-17.63-17.83L265,420.82Z",
    style: {
      fill: "#5B5BF0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246.11,435.9a1.71,1.71,0,0,0-1.7,1.53,1.66,1.66,0,0,0,1.51,1.7,1.82,1.82,0,0,0,1.79-1.64,1.71,1.71,0,0,0-1.77-1.59",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235.4,447.21l1.08-3.23,38.21,12.68s1.56,1.31,1,2.51Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M258.75,441.33c-.06.19-1.07,0-2.23.34s-1.91,1-2.07.88.47-1.18,1.88-1.57S258.85,441.16,258.75,441.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.46,444.33c0,.21-1,.29-1.88.92s-1.37,1.46-1.56,1.39,0-1.22,1.16-2S262.51,444.14,262.46,444.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.36,450.1c-.2,0-.18-1.08.65-2s1.87-1.08,1.9-.9-.7.6-1.37,1.37S263.56,450.14,263.36,450.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.81,436.48c-.14.15-1-.39-2.09-.64s-2.11-.16-2.16-.36,1-.65,2.32-.34S260,436.35,259.81,436.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.27,431.42a4,4,0,0,1-2-.61,9.14,9.14,0,0,1-1.92-1.28,9.78,9.78,0,0,1-1-1,2.47,2.47,0,0,1-.46-.65.9.9,0,0,1,.22-1.08,1.13,1.13,0,0,1,1-.19,2.91,2.91,0,0,1,.73.33,8,8,0,0,1,1.12.8,7.35,7.35,0,0,1,1.5,1.78,3.47,3.47,0,0,1,.7,2c-.11,0-.38-.72-1.12-1.71a8,8,0,0,0-1.5-1.55,7.37,7.37,0,0,0-1.05-.7c-.39-.24-.75-.35-.92-.19s-.07.08,0,.23a1.86,1.86,0,0,0,.34.48,11.34,11.34,0,0,0,.89.93,12.56,12.56,0,0,0,1.72,1.33C259.56,431,260.31,431.31,260.27,431.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.93,431.62a3.31,3.31,0,0,1,.05-2.1,6.55,6.55,0,0,1,.93-2.13,6.17,6.17,0,0,1,.88-1.07,1.73,1.73,0,0,1,1.59-.64,1,1,0,0,1,.67.81,3,3,0,0,1,0,.8,4.7,4.7,0,0,1-.4,1.36,5,5,0,0,1-1.48,1.83c-1.1.81-2,.8-2,.73s.76-.29,1.66-1.12a4.74,4.74,0,0,0,1.2-1.7,4.1,4.1,0,0,0,.31-1.18c.07-.45,0-.84-.16-.84s-.64.16-.91.45a7.88,7.88,0,0,0-.82.94,7.56,7.56,0,0,0-1,1.9C260.06,430.82,260.05,431.62,259.93,431.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.2,366.52c1,7.48-1.54,15.91-4.25,23L264.29,431l-19.55-3s-4.07,4.54-9.28,6.28c-2.33.77-10,2.28-16.31-2.26h0s-8.93,12.44-23,16.2-35.32,5.84-45.62-10.6l49-47.24c1,.24,42.23-27.56,64.5-33.89C264.07,356.49,284.32,352.77,286.2,366.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.29,427.84s.08-.06.26-.16l.8-.42c.71-.38,1.75-.91,3.07-1.64a49.88,49.88,0,0,0,4.68-2.88,24.65,24.65,0,0,0,5.29-4.91,17,17,0,0,0,3.43-7.94,26.38,26.38,0,0,0-.42-10,16.15,16.15,0,0,0-5.39-9.39,20.41,20.41,0,0,0-11-3.92,33.91,33.91,0,0,0-6.05.05,45.45,45.45,0,0,0-5.81,1,69.19,69.19,0,0,0-10.55,3.65c-6.53,2.86-12.2,5.94-17.18,8.07a61.15,61.15,0,0,1-12.15,4.05c-.74.17-1.41.28-2,.36s-1.06.17-1.46.2l-.9.09h-.31l.31-.07.89-.13c.39-.06.88-.13,1.45-.25s1.23-.22,2-.4a64.21,64.21,0,0,0,12-4.2c4.94-2.16,10.59-5.27,17.14-8.17a69,69,0,0,1,10.62-3.7,46.41,46.41,0,0,1,5.87-1,35.05,35.05,0,0,1,6.15-.05,20.82,20.82,0,0,1,11.32,4.05,14.24,14.24,0,0,1,3.67,4.46,20.3,20.3,0,0,1,1.87,5.22,27.06,27.06,0,0,1,.38,10.17,17.49,17.49,0,0,1-3.57,8.09,24.36,24.36,0,0,1-5.42,4.92,49.2,49.2,0,0,1-4.74,2.82c-1.34.7-2.4,1.21-3.12,1.55l-.83.38A1.27,1.27,0,0,1,243.29,427.84Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.55,373.35a57.67,57.67,0,0,1-4.1,6.69,60.53,60.53,0,0,1-4.53,6.4,59.41,59.41,0,0,1,4.1-6.69A60.53,60.53,0,0,1,255.55,373.35Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.45,424.54a34.55,34.55,0,0,1-3.55.92c-2.19.54-5.2,1.37-8.46,2.51s-6.13,2.37-8.18,3.31-3.31,1.57-3.35,1.5a4,4,0,0,1,.82-.55c.55-.33,1.36-.77,2.37-1.28a68.25,68.25,0,0,1,16.72-5.85c1.11-.23,2-.39,2.65-.47A4,4,0,0,1,241.45,424.54Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.94,428.28c-.09,0-.32-.88-1.15-2.1a8.47,8.47,0,0,0-10.06-3.27c-1.39.5-2.12,1.11-2.18,1s.14-.2.48-.47a7.08,7.08,0,0,1,1.56-.9A8.33,8.33,0,0,1,263.1,426a6.89,6.89,0,0,1,.73,1.65C264,428,264,428.28,263.94,428.28Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.36,412.79a2.69,2.69,0,0,1,.26.93,15.17,15.17,0,0,1,.22,2.63,16.28,16.28,0,0,1-2.3,8.36,12.8,12.8,0,0,1-6.7,5.44,9.62,9.62,0,0,1-2.6.5,2.68,2.68,0,0,1-1,0,18.68,18.68,0,0,0,3.45-.8,13,13,0,0,0,6.38-5.37,17.1,17.1,0,0,0,2.38-8.08C179.57,414.15,179.27,412.8,179.36,412.79Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.31,435.22c-.11.09-.63-.36-1.12-1s-.75-1.33-.62-1.4.57.43,1.05,1.09S157.42,435.13,157.31,435.22Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.42,439.57c-.09.11-.65-.28-1.25-.86s-1-1.13-.9-1.22.67.28,1.26.85S161.52,439.46,161.42,439.57Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.28,443.08c-.07.12-.7-.14-1.4-.6s-1.2-.92-1.12-1,.72.16,1.4.6S166.35,443,166.28,443.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.78,445.44c0,.14-.71,0-1.5-.26s-1.38-.62-1.32-.76.73,0,1.49.27S171.82,445.3,171.78,445.44Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.69,446.37c0,.14-.68.2-1.52.12s-1.49-.25-1.47-.39.71-.2,1.52-.12S177.69,446.23,177.69,446.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.67,446.05c0,.14-.65.3-1.48.36a6.7,6.7,0,0,1-1.12,0h0c-.25,0-.4-.06-.41-.13s.13-.14.37-.21h0a6.37,6.37,0,0,1,1.1-.16C183,445.83,183.65,445.9,183.67,446.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.56,445c0,.14-.59.39-1.41.57s-1.49.2-1.51.06.6-.4,1.41-.57S189.53,444.84,189.56,445Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.3,443.23c0,.14-.55.46-1.34.73s-1.47.36-1.51.23.56-.46,1.34-.73S195.25,443.1,195.3,443.23Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.81,440.89c.07.13-.5.52-1.25.86s-1.42.52-1.48.39.51-.52,1.26-.86S200.75,440.76,200.81,440.89Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.07,438c.07.12-.45.56-1.17,1s-1.36.65-1.42.53.45-.57,1.16-1S206,437.89,206.07,438Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211,434.63c.09.12-.39.6-1.07,1.09s-1.29.78-1.37.66.4-.61,1.07-1.09S210.93,434.52,211,434.63Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.64,430.81c.1.11-.34.64-1,1.18s-1.22.9-1.31.79.34-.64,1-1.18S215.54,430.71,215.64,430.81Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220,426.69c.1.11-.31.66-.91,1.22s-1.18.94-1.27.84.3-.64.91-1.22S219.91,426.59,220,426.69Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.74,423c.08.12-.39.61-1.06,1.09s-1.28.78-1.37.67.39-.6,1.06-1.09S224.66,422.89,224.74,423Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230,420.11c.06.13-.5.53-1.23.9s-1.39.56-1.46.43.48-.53,1.23-.9S229.94,420,230,420.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.72,418.33c0,.14-.6.42-1.39.61s-1.48.25-1.52.12.58-.42,1.39-.62S235.7,418.19,235.72,418.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.7,418c0,.15-.69.2-1.51.18s-1.48-.09-1.49-.23.66-.3,1.5-.29S241.71,417.88,241.7,418Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.48,419.54c-.07.13-.71-.06-1.47-.33s-1.39-.54-1.36-.68.73-.1,1.53.19S247.54,419.41,247.48,419.54Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.21,423.89c-.09-.12.36-.61.89-1.21s1-1.1,1.09-1-.12.73-.7,1.37S246.3,424,246.21,423.89Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.92,426.64c0-.14.53-.5,1.28-.81s1.42-.46,1.49-.33-.51.49-1.29.81S241,426.78,240.92,426.64Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.2,428.48c0-.14.55-.46,1.34-.73s1.46-.37,1.51-.23-.56.46-1.34.72S235.25,428.61,235.2,428.48Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.6,430.61c-.06-.13.52-.48,1.3-.79s1.44-.44,1.49-.31-.53.49-1.3.8S229.65,430.75,229.6,430.61Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.07,433c-.06-.13.51-.51,1.27-.83s1.43-.49,1.48-.36-.51.51-1.27.83S224.12,433.08,224.07,433Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.89,261.47s6.54-2,15.23-11.65,12.19-22,13.34-22,6-2.72,17,17.26,7.66,25.07,5.77,25.17-15-2.52-23-1-18,6.46-18,6.46Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.6,273.8l2.59,4.15,1.16,1.85a5.65,5.65,0,0,0,7.53,1.95l13.88-6-9.71-18.33L201.37,266A5.65,5.65,0,0,0,199.6,273.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.33,280.1l5.21,8.56,2.22-.8,15.73,11L235,290.4s-9-3.13-10.9-6.13,0-3.85,0-3.85L219.63,276Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.75,245.52c5.89,10.83,8.74,20.66,6.36,22s-9.08-6.43-15-17.26-8.74-20.66-6.36-22S251.85,234.68,257.75,245.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "198.84 280.12 202.62 278.62 199.89 274.26 197.13 276.27 198.84 280.12",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "221.16 277.54 211.27 284.93 209.79 282.49 221.16 277.54",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.89 274.26 202.62 278.62 201.84 278.93 199.56 274.5 199.89 274.26",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.63,275.11a21.52,21.52,0,0,0,4.18-2,21.53,21.53,0,0,0,3.94-2.43,21.83,21.83,0,0,0-4.18,2A21.53,21.53,0,0,0,202.63,275.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.24,272.49a18.27,18.27,0,0,0,3.77-1.93,19,19,0,0,0,3.53-2.36,35.8,35.8,0,0,0-7.3,4.29Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.34,277.84a3.33,3.33,0,0,0,1.19-.36l1.25-.52c.46-.21.94-.49,1.45-.77a16.5,16.5,0,0,0,3.52-2.33,20.42,20.42,0,0,0-3.76,1.89c-.51.28-1,.58-1.42.8s-.85.43-1.19.61C204.72,277.52,204.31,277.77,204.34,277.84Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.24,243.79s5.52-4,9.26,3.56-2.24,9.31-2.24,9.31A52.11,52.11,0,0,1,247.24,243.79Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.41,234.94a7.34,7.34,0,0,0,.33,1.48c.26.94.62,2.3,1.12,4,.3.82.64,1.71,1,2.67l.56,1.49c.1.25.19.51.29.78s.24.51.36.77l1.56,3.27c.13.29.27.57.41.86s.31.56.47.84l1,1.71,1,1.71c.17.27.32.56.5.82s.37.53.54.79l2.08,3c.17.23.32.47.49.69l.54.65,1,1.22,1.83,2.2c1.21,1.26,2.21,2.24,2.9,2.93a8,8,0,0,0,1.12,1,10.49,10.49,0,0,0-1-1.15l-2.78-3L254,261.38l-1-1.23-.52-.65c-.17-.22-.32-.46-.48-.69l-2-3-.53-.78c-.19-.26-.33-.55-.5-.82l-1-1.7c-.33-.57-.66-1.14-1-1.69-.15-.28-.33-.55-.47-.84s-.27-.57-.41-.85l-1.57-3.23c-.12-.26-.26-.51-.36-.77s-.21-.52-.31-.77c-.2-.51-.39-1-.58-1.47l-1.05-2.64c-.53-1.63-.95-3-1.26-3.91A10.21,10.21,0,0,0,240.41,234.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.54,280.44a1.69,1.69,0,0,1,1.17,2.05c-.43,1.7-1.13,4.37-1.69,6a4.49,4.49,0,0,1-.75,1.48,1.4,1.4,0,0,1-2.55-.72,4.46,4.46,0,0,1,.15-1.74c.35-1.59,1-4,1.56-5.91a1.69,1.69,0,0,1,2.11-1.16Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.25,283.2a1.69,1.69,0,0,1,1.17,2.05c-.43,1.7-1.13,4.37-1.7,6a4.31,4.31,0,0,1-.75,1.48,1.53,1.53,0,0,1-1.48.56,1.57,1.57,0,0,1-1.06-1.29,4.67,4.67,0,0,1,.14-1.74c.36-1.58,1-4,1.56-5.91a1.71,1.71,0,0,1,2.12-1.16Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.86,284.86a1.48,1.48,0,0,1,1,1.78c-.37,1.47-1,3.78-1.47,5.19a3.83,3.83,0,0,1-.65,1.29,1.21,1.21,0,0,1-2.2-.63,3.87,3.87,0,0,1,.12-1.51c.31-1.37.87-3.43,1.35-5.12a1.48,1.48,0,0,1,1.83-1Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.83,285.19a1.48,1.48,0,0,1,1,1.79c-.37,1.48-1,3.8-1.48,5.22a3.74,3.74,0,0,1-.65,1.29,1.21,1.21,0,0,1-2.21-.63,3.92,3.92,0,0,1,.12-1.52c.31-1.37.87-3.45,1.36-5.14a1.48,1.48,0,0,1,1.84-1Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.6,290a10.36,10.36,0,0,1,.73-3.2,10.57,10.57,0,0,1,1.24-3.05,10.21,10.21,0,0,1-.74,3.2A10.73,10.73,0,0,1,224.6,290Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.23,292.27A41,41,0,0,1,232.1,286a13.93,13.93,0,0,1-1.87,6.28Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.44,291.91a41.54,41.54,0,0,1,1.87-6.29,13.92,13.92,0,0,1-1.87,6.29Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.25,207.35c.11.08-4,5.65-9.16,12.43s-9.46,12.21-9.57,12.12,4-5.65,9.15-12.43S278.13,207.26,278.25,207.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.08,223.22c.06.13-8.56,4.26-19.26,9.22s-19.41,8.88-19.47,8.75,8.56-4.26,19.25-9.22S305,223.09,305.08,223.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.08,256.24c0,.14-6.16-.33-13.72-1.06s-13.69-1.44-13.68-1.58,6.16.33,13.73,1.06S301.1,256.1,301.08,256.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.42,274.76l6.79,38.6a12.7,12.7,0,0,0,14.3,10.28h0a12.56,12.56,0,0,0,10.8-14.44l-1.1-6.64s9.5-2.58,8.51-12.12c-.48-4.6-2.24-14-3.94-22.46A18.21,18.21,0,0,0,158,253.75h0A17.76,17.76,0,0,0,143.42,274.76Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.23,302.58a22.93,22.93,0,0,1-13-2.11S165,307,174.54,305Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.71,274.42a1.37,1.37,0,0,1-1.17,1.52,1.32,1.32,0,0,1-1.56-1.06,1.37,1.37,0,0,1,1.17-1.53A1.32,1.32,0,0,1,176.71,274.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177,272.11c-.15.2-1.29-.45-2.77-.27s-2.49,1-2.67.86,0-.41.48-.8a3.94,3.94,0,0,1,2.11-.92,3.68,3.68,0,0,1,2.24.45C176.91,271.72,177.11,272,177,272.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.74,276.1a1.38,1.38,0,0,1-1.17,1.53,1.33,1.33,0,0,1-1.57-1.07,1.37,1.37,0,0,1,1.17-1.52A1.33,1.33,0,0,1,162.74,276.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.67,274c-.15.19-1.28-.45-2.77-.28s-2.49,1-2.67.87.05-.41.49-.81a3.8,3.8,0,0,1,2.11-.91,3.74,3.74,0,0,1,2.23.44C162.56,273.64,162.75,274,162.67,274Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.33,285.16a10.52,10.52,0,0,1,2.37-.7c.37-.08.72-.2.76-.46a1.93,1.93,0,0,0-.39-1.08l-1.45-2.72c-2-3.87-3.55-7.08-3.39-7.16s1.94,3,4,6.88c.49.95,1,1.86,1.4,2.74a2.1,2.1,0,0,1,.37,1.44.94.94,0,0,1-.56.62,2.53,2.53,0,0,1-.63.16A10.06,10.06,0,0,1,169.33,285.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.08,286.67c.24,0,.43,1.54,1.94,2.52s3.21.6,3.24.82-.34.35-1.07.45a4.09,4.09,0,0,1-2.7-.59,3.48,3.48,0,0,1-1.52-2.13C164.83,287.08,165,286.67,165.08,286.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.39,269.14c-.1.41-1.61.39-3.33.79s-3.07,1-3.34.71c-.13-.16.07-.57.6-1a6.09,6.09,0,0,1,5.08-1.14C162.07,268.66,162.43,268.94,162.39,269.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.21,268.82c-.22.36-1.29.13-2.52.25s-2.25.48-2.53.16c-.12-.15,0-.51.42-.87a3.47,3.47,0,0,1,2-.78,3.58,3.58,0,0,1,2.09.44C176.12,268.32,176.3,268.64,176.21,268.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.83,251.68a3.37,3.37,0,0,0-4.39.27,3,3,0,0,0-.85-4,5.16,5.16,0,0,0-4.37-.63,14.83,14.83,0,0,0-4.09,2,1.54,1.54,0,0,0-.67-1.56,3.7,3.7,0,0,0-1.72-.54,13.11,13.11,0,0,0-7.21,1.62,45,45,0,0,0-6.67,4.53h0a31.87,31.87,0,0,0-6.1,6.52l-.08.07c-1.41,1.26-2.6,5.06-2.39,6.92.79,6.87,3.07,10.84,4.35,17.34a2.28,2.28,0,0,0,.49,1.21c.79.82,2.21.12,3-.74a12.28,12.28,0,0,0,2.54-7.73c.09-2.76-.31-5.51-.24-8.27v-.2a15.5,15.5,0,0,1,.2-2.1c.12-.45,1.29-4.39,5.08-5,4-.68,11.95,3.22,15.88,2.6s4.14-3.39,4.14-3.39l2.31,4.7a14.23,14.23,0,0,0,.37-5.87,6.67,6.67,0,0,0,2-3.43A4.41,4.41,0,0,0,178.83,251.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.19,278.86c-.17-.05-6.87-1.18-5.9,5.31s7.39,4.19,7.37,4S147.19,278.86,147.19,278.86Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.28,286s-.1.1-.28.21a1.19,1.19,0,0,1-.86.15,2.85,2.85,0,0,1-1.69-2.32,3.86,3.86,0,0,1,.08-1.67,1.31,1.31,0,0,1,.74-1,.6.6,0,0,1,.72.21c.11.17.09.31.13.31s.12-.13,0-.39a.83.83,0,0,0-.32-.37.92.92,0,0,0-.66-.07,1.64,1.64,0,0,0-1,1.18,3.87,3.87,0,0,0-.12,1.87,3,3,0,0,0,2.09,2.56,1.25,1.25,0,0,0,1-.33C146.29,286.16,146.3,286,146.28,286Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.4,325.85a1.2,1.2,0,0,1,.57-.09,2.24,2.24,0,0,1,1.48.74,3.22,3.22,0,0,1,.86,2.46,14.31,14.31,0,0,1-.76,3.36,4.58,4.58,0,0,0,.23,3.85c.71,1.24,2.16,2.19,2.75,3.92a4.61,4.61,0,0,1-1.45,5,4.68,4.68,0,0,1-2.7,1.05,9.88,9.88,0,0,1-2.89-.47,5.24,5.24,0,0,0-2.7-.17,3.92,3.92,0,0,0-2,1.62,13.82,13.82,0,0,1-1.7,2.13,3.4,3.4,0,0,1-2.53.93,5,5,0,0,1-4-2.65,9.78,9.78,0,0,1-1-4.08c-.07-1.28,0-2.43,0-3.43a17.18,17.18,0,0,0-.22-2.55,13.07,13.07,0,0,0-.61-2.1,2.07,2.07,0,0,1,.28.5,6.65,6.65,0,0,1,.52,1.56,14.26,14.26,0,0,1,.32,2.58c0,1,0,2.16.13,3.42a9.33,9.33,0,0,0,1,3.89,4.61,4.61,0,0,0,3.63,2.38,2.89,2.89,0,0,0,2.17-.82,13.33,13.33,0,0,0,1.63-2.06,4.43,4.43,0,0,1,2.26-1.82,5.6,5.6,0,0,1,3,.17,10.05,10.05,0,0,0,2.74.45,4.18,4.18,0,0,0,2.41-.93,4.13,4.13,0,0,0,1.32-4.47c-.49-1.53-1.9-2.5-2.68-3.85a4.06,4.06,0,0,1-.57-2.17,8.26,8.26,0,0,1,.36-2,14.47,14.47,0,0,0,.83-3.28,3,3,0,0,0-.72-2.31,2.24,2.24,0,0,0-1.34-.76C132.6,325.82,132.4,325.88,132.4,325.85Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.15,395.84s.07.24.3.62a2.61,2.61,0,0,0,1.55,1.08,3.15,3.15,0,0,0,2.86-.6,6,6,0,0,0,1.91-3.5c.32-1.49.26-3.19.55-5a8,8,0,0,1,.92-2.73,4.56,4.56,0,0,1,2.3-2.06,6.48,6.48,0,0,1,3.21-.29c1.09.11,2.16.36,3.24.5a7.85,7.85,0,0,0,3.27-.16,7.47,7.47,0,0,0,2.92-1.62,6.35,6.35,0,0,0,1.8-2.79,5.34,5.34,0,0,0-.06-3.19,5.49,5.49,0,0,0-4.35-3.87c-2-.22-3.8.75-5.69.79a5.4,5.4,0,0,1-2.64-.6,12.46,12.46,0,0,1-2.07-1.33,12.65,12.65,0,0,0-3.5-2.14,3.6,3.6,0,0,0-3,.2,2.72,2.72,0,0,0-1.28,1.39,6.4,6.4,0,0,0-.16.67,1.57,1.57,0,0,1,.06-.7,2.74,2.74,0,0,1,1.28-1.54,3.86,3.86,0,0,1,1.4-.48,4.26,4.26,0,0,1,1.74.19,12.54,12.54,0,0,1,3.64,2.12,7.12,7.12,0,0,0,4.47,1.79,13.88,13.88,0,0,0,2.73-.51,8.42,8.42,0,0,1,3-.32,5.94,5.94,0,0,1,4.77,4.18,5.72,5.72,0,0,1,.07,3.5,6.87,6.87,0,0,1-1.94,3,7.89,7.89,0,0,1-3.13,1.74,8.17,8.17,0,0,1-3.47.16c-1.12-.15-2.19-.39-3.23-.51a6.05,6.05,0,0,0-3,.25,4,4,0,0,0-2.08,1.84,7.89,7.89,0,0,0-.9,2.57c-.29,1.77-.26,3.49-.61,5a6.29,6.29,0,0,1-2.09,3.65,3.34,3.34,0,0,1-3.09.56,2.61,2.61,0,0,1-1.59-1.22A1.46,1.46,0,0,1,135.15,395.84Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.12,335.25a3.69,3.69,0,0,1,.69-.93,5.34,5.34,0,0,1,3-1.5,5.13,5.13,0,0,1,4.78,1.9,5.49,5.49,0,0,1,1.21,3.09,8.2,8.2,0,0,0,.76,3.48,2.7,2.7,0,0,0,1.46,1.09,7.88,7.88,0,0,0,2,.31c.7,0,1.42,0,2.17.1a4.08,4.08,0,0,1,2.19.78,2.69,2.69,0,0,1,.76,1,2.66,2.66,0,0,1,.2,1.25,4.17,4.17,0,0,1-1,2.26,6.39,6.39,0,0,1-2,1.57c-.75.38-1.54.69-2.31,1.05a8.14,8.14,0,0,0-2.13,1.31,4.13,4.13,0,0,0-1.25,2.13c-.41,1.68,0,3.5-.12,5.4a7,7,0,0,1-.76,2.8,3.33,3.33,0,0,1-2.38,1.79,3.69,3.69,0,0,1-2.87-1,8.75,8.75,0,0,1-1.91-2.33,24.83,24.83,0,0,0-1.54-2.45,4.52,4.52,0,0,0-2.13-1.66,3.83,3.83,0,0,0-2.62.17,15.5,15.5,0,0,0-2.44,1.3,13.88,13.88,0,0,1-2.48,1.29,7.68,7.68,0,0,1-2.75.46,8.66,8.66,0,0,1-5-1.76,7.1,7.1,0,0,1-2.74-4.23,4.9,4.9,0,0,1,1.19-4.57,4.78,4.78,0,0,1,2.06-1.06,17,17,0,0,1,2.15-.37,7,7,0,0,0,3.68-1.25,7.32,7.32,0,0,0,2-3c.43-1.07.71-2.13,1.08-3.1a9.08,9.08,0,0,1,1.35-2.55,11.79,11.79,0,0,1,1.74-1.68,6.16,6.16,0,0,1,3-1.45,1.39,1.39,0,0,1,1.11.31,1.78,1.78,0,0,0-1.1-.2,6.14,6.14,0,0,0-2.87,1.5,11.1,11.1,0,0,0-1.68,1.68,9.24,9.24,0,0,0-1.27,2.49c-.35,1-.62,2-1,3.12a7.56,7.56,0,0,1-2,3.13,7.23,7.23,0,0,1-3.87,1.36c-1.37.21-2.9.36-4,1.36a4.45,4.45,0,0,0-1,4.16,6.72,6.72,0,0,0,2.58,3.94,8.24,8.24,0,0,0,4.73,1.64,7,7,0,0,0,2.56-.43,13.79,13.79,0,0,0,2.4-1.26A15.79,15.79,0,0,1,165,356.4a4.32,4.32,0,0,1,3-.18,5,5,0,0,1,2.38,1.83,23.47,23.47,0,0,1,1.58,2.51,8.67,8.67,0,0,0,1.79,2.19,3.13,3.13,0,0,0,2.46.83,2.75,2.75,0,0,0,2-1.52,6.57,6.57,0,0,0,.7-2.58c.1-1.79-.3-3.66.15-5.49a4.64,4.64,0,0,1,1.4-2.37,8.36,8.36,0,0,1,2.26-1.39c.79-.36,1.57-.66,2.3-1a5.87,5.87,0,0,0,1.85-1.45,3.73,3.73,0,0,0,1-2,2.24,2.24,0,0,0-.16-1,2.34,2.34,0,0,0-.64-.82,3.68,3.68,0,0,0-2-.69c-.71-.08-1.43-.08-2.14-.12a8.16,8.16,0,0,1-2.09-.35,3.12,3.12,0,0,1-1.64-1.25,8.34,8.34,0,0,1-.78-3.64,5.24,5.24,0,0,0-1.1-3A5,5,0,0,0,172.8,333a5.37,5.37,0,0,0-2.91,1.37A9.74,9.74,0,0,0,169.12,335.25Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.29,318.37a3.48,3.48,0,0,1-2.08,1,6.51,6.51,0,0,1-2.54,0,4.44,4.44,0,0,1-2.73-1.57,5.85,5.85,0,0,1-1-3,8,8,0,0,1,.17-2.53,3.39,3.39,0,0,1,1.07-2,9,9,0,0,0-.7,2.12,8.57,8.57,0,0,0-.07,2.41,5.79,5.79,0,0,0,.93,2.71,4,4,0,0,0,2.41,1.41,7,7,0,0,0,2.38.09A10.22,10.22,0,0,0,152.29,318.37Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.34,315.82s0,.1-.07.27a2.76,2.76,0,0,1-.39.72,4.49,4.49,0,0,1-2.49,1.66,4.64,4.64,0,0,1-2.11,0,5.6,5.6,0,0,1-2.13-1.14,6.85,6.85,0,0,0-2.1-1.29,1.91,1.91,0,0,0-2.13.84,18,18,0,0,0-1.23,2.44,5,5,0,0,1-1.77,2,4.72,4.72,0,0,1-6.67-1.44,2,2,0,0,1-.41-1s.17.35.57.9a5,5,0,0,0,2.26,1.69,4.54,4.54,0,0,0,5.56-2.38,19,19,0,0,1,1.26-2.51,2.69,2.69,0,0,1,1.19-1,2.34,2.34,0,0,1,1.5-.06,7.17,7.17,0,0,1,2.27,1.4,5.21,5.21,0,0,0,1.93,1.1,4.34,4.34,0,0,0,1.93,0,4.45,4.45,0,0,0,2.41-1.42C195.16,316.17,195.3,315.8,195.34,315.82Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.47,355.08a5.3,5.3,0,0,1-1.11-.72,22.78,22.78,0,0,1-2.73-2.38,13,13,0,0,1-1.59-2,6.65,6.65,0,0,1-1-2.76,5.39,5.39,0,0,1,.51-3.21,4,4,0,0,1,1.13-1.34,12.16,12.16,0,0,1,1.47-.94,6.38,6.38,0,0,0,1.33-1,3.15,3.15,0,0,0,.77-1.32,7.74,7.74,0,0,0,.1-3,15,15,0,0,1-.21-2.88,3.52,3.52,0,0,1,.93-2.39,5.31,5.31,0,0,1,3.37-1.35,1.44,1.44,0,0,1,1.24.46,2.36,2.36,0,0,0-1.23-.26,5.32,5.32,0,0,0-3.12,1.41,3.16,3.16,0,0,0-.76,2.16,16.68,16.68,0,0,0,.25,2.79,7.86,7.86,0,0,1-.08,3.23,3.58,3.58,0,0,1-.89,1.54,6.4,6.4,0,0,1-1.44,1.05A5.38,5.38,0,0,0,197,344.3a5.06,5.06,0,0,0-.49,2.92,8,8,0,0,0,2.38,4.51C201,353.93,202.53,355,202.47,355.08Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.56,374.92a1.38,1.38,0,0,1,.46,0,10.92,10.92,0,0,1,1.34.08,12.92,12.92,0,0,1,4.74,1.38,8.63,8.63,0,0,1,4.48,5.67,6,6,0,0,1-.62,4.33,5.86,5.86,0,0,1-3.76,2.81,5.35,5.35,0,0,1-2.43-.13,3.3,3.3,0,0,0-2.08,0,4,4,0,0,0-1.62,1.25A11.57,11.57,0,0,0,181,392a6.71,6.71,0,0,1-2.61,3,4.93,4.93,0,0,1-3.43.41,4.32,4.32,0,0,1-2.39-1.56,4.78,4.78,0,0,1-.92-1.94,4.11,4.11,0,0,1-.07-1.35,1.54,1.54,0,0,1,.1-.46,7.2,7.2,0,0,0,.17,1.76,4.67,4.67,0,0,0,.95,1.81A4,4,0,0,0,175,395a4.6,4.6,0,0,0,3.15-.43,6.38,6.38,0,0,0,2.39-2.83,6.45,6.45,0,0,1,3-3.22,3.8,3.8,0,0,1,2.38,0,4.74,4.74,0,0,0,2.21.13,5.38,5.38,0,0,0,3.42-2.56,5.57,5.57,0,0,0,.59-4,8.34,8.34,0,0,0-4.19-5.45,13.64,13.64,0,0,0-4.58-1.5C182.2,375,181.55,375,181.56,374.92Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.83,408a6.81,6.81,0,0,0-.93-2.06,5.07,5.07,0,0,0-1.87-1.51,4,4,0,0,0-5.16,1.38A5,5,0,0,0,154,408a6.75,6.75,0,0,0,.22,2.25s-.17-.17-.33-.55a4.05,4.05,0,0,1-.26-1.74,5.18,5.18,0,0,1,.83-2.48,4.31,4.31,0,0,1,5.77-1.54,5.1,5.1,0,0,1,2,1.73,4,4,0,0,1,.64,1.63C162.89,407.72,162.86,408,162.83,408Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166,422.5s-.09-.47-.45-1.23a5.25,5.25,0,0,0-2.4-2.46,5,5,0,0,0-4.87.37,7.65,7.65,0,0,0-2,2.28,7.23,7.23,0,0,1-1.14,1.3,2.74,2.74,0,0,1-1.75.65,4.36,4.36,0,0,1-3-1.81,10,10,0,0,0-2.12-2.21,3.74,3.74,0,0,0-2.59-.47,5.27,5.27,0,0,0-2.19.91,8.92,8.92,0,0,0-2.3,2.65,9.1,9.1,0,0,1-.69,1.13,4.57,4.57,0,0,1,.51-1.22,8.39,8.39,0,0,1,2.26-2.85,5.34,5.34,0,0,1,2.34-1,4.15,4.15,0,0,1,2.92.48,10.19,10.19,0,0,1,2.25,2.29,3.9,3.9,0,0,0,2.62,1.62c1.07,0,1.85-.87,2.46-1.73a8.25,8.25,0,0,1,2.17-2.38,5.18,5.18,0,0,1,7.73,2.41,4.11,4.11,0,0,1,.25,1C166.06,422.38,166.06,422.5,166,422.5Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.71,386.22a11.45,11.45,0,0,0-2.88-1.27,9.08,9.08,0,0,0-3.36-.18,8.11,8.11,0,0,0-3.8,1.48,7,7,0,0,0-2.4,3.25,7.2,7.2,0,0,0-.36,3.32,9.43,9.43,0,0,0,1.06,2.94s-.25-.2-.56-.67a6.07,6.07,0,0,1-.87-2.22,7.29,7.29,0,0,1,2.82-7,8.25,8.25,0,0,1,4-1.53,8.7,8.7,0,0,1,3.52.3,6.86,6.86,0,0,1,2.14,1C173.52,386,173.73,386.2,173.71,386.22Z",
    style: {
      fill: "#fafafa"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailCampaignCreated);
export default __webpack_public_path__ + "static/media/Email-campaign-created.347f3c06fc7fc00711fa9846355eac19.svg";
export { ForwardRef as ReactComponent };